import React from 'react';

import { Tutorial , ICON as tutorialIcon } from '../Tutorial';
export interface Module {
    id: number;
    sort: number;
    name: string;
    slug: string;
    icon: string;
    element: (params: ModuleProps<any>) => JSX.Element;
}

export type ModuleProps<T> = {
    currentEx: number;
    currentExJson: T;
    maxEx: number;
    setEndTime: React.Dispatch<React.SetStateAction<string>>;
    setHits: React.Dispatch<React.SetStateAction<number>>;
    setMisses: React.Dispatch<React.SetStateAction<number>>;
    checkIfIsFinished: Function;
    checkAnswers: Function;
    isReloadingContent: React.ComponentState;
    sortFeedback: Function;
    acessivel?: boolean;
};

export function getModuleByProp(id: number, modulos: any) {
    const module = modulos.find(module => {
        if (module.id === id) {
            module.element = (params: ModuleProps<any>) => {
                    return (
                        <Tutorial
                            currentEx={params.currentEx}
                            currentExJson={params.currentExJson}
                            maxEx={params.maxEx}
                            setEndTime={params.setEndTime}
                            setHits={params.setHits}
                            setMisses={params.setMisses}
                            checkIfIsFinished={params.checkIfIsFinished}
                            checkAnswers={params.checkAnswers}
                            isReloadingContent={params.isReloadingContent}
                            sortFeedback={params.sortFeedback}
                            acessivel={params.acessivel}
                        />
                    );
                }
            return module;
        }
    });


    return (
        module ??
        ({
            id: 0,
            sort: 0,
            name: 'Error',
            icon: tutorialIcon,
            slug: 'Error',
            element: () => {
                return <h1>Curso não existe</h1>;
            }
        } as Module)
    );
}

export const MODULES: Module[] = [
    {
        id: 13,
        sort: 0,
        name: 'Introdução a Lógica',
        icon: tutorialIcon,
        slug: 'tutorial',
        element: (params: ModuleProps<any>) => {
            return (
                <Tutorial
                    currentEx={params.currentEx}
                    currentExJson={params.currentExJson}
                    maxEx={params.maxEx}
                    setEndTime={params.setEndTime}
                    setHits={params.setHits}
                    setMisses={params.setMisses}
                    checkIfIsFinished={params.checkIfIsFinished}
                    checkAnswers={params.checkAnswers}
                    isReloadingContent={params.isReloadingContent}
                    sortFeedback={params.sortFeedback}
                    acessivel={params.acessivel}
                />
            );
        }
    },
];
